import CustomButton from '../../../common/components/CustomButton';
import CustomUpload from '../../../common/components/CustomUpload';
import PopupContainer from '../../../common/components/PopupContainer';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeUploadForm2OffvocalPopupFileName = 'song_vocal_off';

// 歌なし音源のアップロード（ポップアップ）
export default function KaraokeUploadForm2OffvocalPopup({
  getFiles,
  setFiles,
  getErrors,
  onClose,
} : {
  getFiles: (name: KaraokeUploadForm2OffvocalPopupFileName) => FileList|null,
  setFiles: (name: KaraokeUploadForm2OffvocalPopupFileName, value: FileList|null) => void,
  getErrors: (name: KaraokeUploadForm2OffvocalPopupFileName) => FieldValidationErrorsType,
  onClose: () => void,
}) {
  return (
    <PopupContainer title="歌なし音源" onClose={() => onClose()}>
      <div className="list__body">
        <div className="list__addtext">
          歌なし音源をアップロードしてください。
          <br className="sp" />
          この音声がカラオケ店で流れます。
          <br />
          <br />
          <p className="list__addtext_item">・ご提出いただく「ミュージックビデオ」または「歌あり音源」と全く同じ構成、テンポのカラオケ音源を提出してください。</p>
          <br />
          <p className="list__addtext_item">・ガイドメロディのON/OFFに対応しておりませんので、ガイドメロディを入れたい場合は歌なし音源に含めてください。</p>
          <br />
          <p className="list__addtext_item">・ミュージックビデオに効果音やセリフが含まれていて、それをカラオケ店で流したい場合も「歌なし音源」に含めてください。</p>
          <br />
          <p className="list__addtext_item">・歌から始まる曲など冒頭にカウントが必要な場合も「歌なし音源」に含めてください。</p>
        </div>
        <div className="form__body">
          <dl>
            <dd>
              <CustomUpload
                type="audio"
                description="wav, mp3 (150MBまで)"
                files={getFiles('song_vocal_off')}
                onSelectFiles={(value) => setFiles('song_vocal_off', value)}
                onDeleteFiles={() => setFiles('song_vocal_off', null)}
                validationErrors={getErrors('song_vocal_off')}
              />
              <p className="text_info_on" />
            </dd>
          </dl>
        </div>
        <ul>
          <li className="bt w100">
            <CustomButton type="default" disabled={Object.keys(getErrors('song_vocal_off')).length > 0} onClick={() => onClose()}>設定する</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
